import { AbstractControl, ValidatorFn } from '@angular/forms';

export function conditionalRequiredValidator(inputName: string, selectName: string, selectValueToCheck: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const selectControl = control.get(selectName);
        const inputControl = control.get(inputName);

        if (!selectControl || !inputControl) {
            return null;
        }

        const selectValue = selectControl.value;

        if (selectValue === selectValueToCheck) {
            return inputControl.value ? null : { 'conditionalRequired': true };
        } else {
            return null;
        }
    };
}